import React, { useState, useCallback, useEffect } from 'react';
import useMeasure from 'react-use-measure';
import { useSpring, animated } from 'react-spring';
import { useGesture } from 'react-use-gesture';
import classnames from 'classnames';
import Thumb from './Thumb';
import { getCFUrl } from '../../helpers';
import placeholder from '../../img/pdf-placeholder.png';
const isClient = typeof window !== 'undefined';

const PdfThumbs = ({
  dps,
  numPages,
  pageNumber,
  showThumbs,
  classes,
  thumbs,
  status,
  handlePageChange,
}) => {
  const processing = status === 'PROCESSING_THUMBS';
  // how to get the widhth
  const [ref, container] = useMeasure();
  const [{ y }, set] = useSpring(() => {
    y: 0;
  });
  const [disableClick, setDisableClick] = useState(false);

  const bounds = useCallback(() => {
    if (!isClient) return;
    return {
      bottom: 0,
      top: -container.height + (window.innerHeight - 64 * 2),
    }; // just doubling top margin to get some extra space at the bottom for the buttons
  }, [container.height, isClient && window.innerHeight]);

  useEffect(() => {
    console.log('thumbs container dps reset pos');
    set({ y: 0 });
  }, [dps]);

  const bind = useGesture(
    {
      onWheel: ({ wheeling, movement: [_, oy] }) => {
        set({ y: oy, immediate: wheeling });
      },
      onDrag: ({ down, tap, movement: [_, oy] }) => {
        if (tap) setDisableClick(false);
        set({ y: oy, immediate: down });
      },
      onDragStart: () => setDisableClick(true),
      onDragEnd: () =>
        setTimeout(() => {
          setDisableClick(false);
        }, 50),
    },
    {
      wheel: {
        bounds: bounds(),
        initial: () => [0, y.get()],
      },
      drag: {
        filterTaps: true,
        bounds: bounds(),
        rubberband: true,
        initial: () => [0, y.get()],
      },
    }
  );
  return (
    <div
      className={classnames(
        classes.pdfThumbContainer,
        showThumbs && classes.pdfThumbContainerIn
      )}
    >
      <animated.div
        className={classes.pdfThumbDoc}
        ref={ref}
        {...bind()}
        style={{ y, touchAction: 'none' }}
      >
        {thumbs &&
          thumbs.map(({ key }, i) => {
            const currPage = i + 1;
            const url = getCFUrl(key);
            const nextUrl = thumbs[i + 1] && thumbs[i + 1].key;
            return dps ? (
              currPage === 1 ||
              (currPage === numPages && numPages % 2 === 0) ? (
                <Thumb
                  disableClick={disableClick}
                  isDps={false}
                  classes={classes}
                  handleClick={handlePageChange}
                  url={processing ? placeholder : url}
                  pageNumber={pageNumber}
                  currPage={currPage}
                />
              ) : (
                currPage + 1 <= numPages &&
                i % 2 === 1 && (
                  <Thumb
                    isDps
                    disableClick={disableClick}
                    handleClick={handlePageChange}
                    nextUrl={
                      nextUrl && (processing ? placeholder : getCFUrl(nextUrl))
                    }
                    classes={classes}
                    onClick={handlePageChange}
                    url={processing ? placeholder : url}
                    pageNumber={pageNumber}
                    currPage={currPage}
                  />
                )
              )
            ) : (
              <Thumb
                isDps={false}
                classes={classes}
                handleClick={handlePageChange}
                disableClick={disableClick}
                url={processing ? placeholder : url}
                pageNumber={pageNumber}
                currPage={currPage}
              />
            );
          })}
      </animated.div>
    </div>
  );
};

export default PdfThumbs;
